<template>
  <div>
    <template v-if="formdata.onlyHeader">
      <div
        class="XVradiobuttonlistHorizontal"
        :class="{ showHeader: formdata.tblQuestionShowHeader }"
        style="margin: 0"
      >
        <div
          class="hidden-md scrollfit radiobuttonlist"
          :style="{ gridTemplateColumns: 'repeat(' + datalist.length + ', 1fr)' }"
        >
          <label v-for="(listitem, index) in datalist" :key="index" class="hzlistholder">
            <div v-if="headersVisible" class="hzlistlabel">{{ listitem.labelText }}</div>
          </label>
        </div>
      </div>
    </template>
    <template v-if="labelAlignTop && !formdata.onlyHeader">
      <div class="XVradiobuttonlistHorizontal">
        <div
          v-for="(listitem, index) in datalist"
          :key="index"
          class="hzlistholder labelAlignTop pointer"
          v-on:click="clickradio(listitem.value)"
        >
          <div v-if="headersVisible" class="hzlistlabel">{{ listitem.labelText }}</div>
          <span class="radioholder">
            <label class="input-radio">
              <input
                :disabled="disabled"
                type="radio"
                v-focus="focus === true && index === 0"
                :value="listitem.value"
                :checked="listitem.value == value"
                :name="id"
              />
              <span></span>
            </label>
          </span>
        </div>
      </div>
    </template>
    <template v-if="!labelAlignTop && !formdata.onlyHeader">
      <div
        class="XVradiobuttonlistHorizontal"
        v-if="wXL === true"
        :class="{ showHeader: formdata.tblQuestionShowHeader }"
      >
        <div
          class="hidden-md pointer scrollfit radiobuttonlist"
          :style="{ gridTemplateColumns: 'repeat(' + datalist.length + ', 1fr)' }"
        >
          <label
            v-for="(listitem, index) in datalist"
            :key="index"
            class="hzlistholder pointer"
            v-on:click="clickradio(listitem.value)"
          >
            <label v-if="headersVisible" class="hzlistlabel">{{ listitem.labelText }}</label>
            <span class="radioholder">
              <label class="input-radio">
                <input
                  :disabled="disabled"
                  type="radio"
                  v-focus="focus === true && index === 0"
                  :value="listitem.value"
                  :checked="listitem.value == value"
                  :name="id"
                />
                <span></span>
              </label>
            </span>
          </label>
        </div>
      </div>
      <div v-if="wXL === false && datalist.length <= 3">
        <div class="XVradiobuttonlist radiobuttonlist pointer">
          <div
            v-for="(listitem, index) in datalist"
            :key="index"
            v-on:click="clickradio(listitem.value)"
            class="radioholder margin10 pointer"
          >
            <label class="input-radio">
              <input
                :disabled="disabled"
                type="radio"
                v-focus="focus === true && index === 0"
                :value="listitem.value"
                :checked="listitem.value == value"
                :name="id"
                :id="id"
              />
              <span></span>
            </label>
            <label v-if="headersVisible" class="radiolabel pointer">{{ listitem.labelText }}</label>
          </div>
          <!-- <span>{{$v}}</span> -->
        </div>
      </div>
      <div v-if="wXL === false && datalist.length > 3">
        <select
          :value="value"
          :disabled="disabled"
          class="form-control vuexaurumselect pointer"
          @change="selectchanged($event.target.value)"
        >
          <option disabled selected value>{{ placeholder }}</option>
          <option v-for="(listitem, index) in datalist" v-bind:value="listitem.value" :key="index">
            {{ listitem.labelText }}
          </option>
        </select>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'XVradiobuttonlistHorizontal',
  props: {
    focus: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
    datalist: {
      type: Array,
      reuired: true,
    },
    value: {},
    formdata: {},
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    labelAlignTop: {
      type: Boolean,
      default: false,
    },
    headersVisible: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    clickradio: function (val) {
      if (this.disabled === true) {
        return false
      }
      this.$emit('input', val) // prop value en deze input event handler zorgen er voor dat je een v-model kan toepassen op dit custom component
      this.$emit('formvaluechanged', {
        type: this.$vnode.componentOptions.tag,
        value: val,
        id: this.id,
        formdata: this.formdata,
      })
    },
    selectchanged: function (val) {
      let dliobj = this.datalist.filter((v) => {
        return String(v.value) === String(val)
      })[0]
      this.$emit('input', val)
      this.$emit('formvaluechanged', {
        type: this.$vnode.componentOptions.tag,
        value: dliobj.value,
        labelText: dliobj.labelText,
        id: this.id,
        formdata: this.formdata,
      })
    },
  },
}
</script>
